/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type expenseRow_project = {
    readonly id: string;
    readonly budgetType: BUDGET_TYPE | null;
    readonly companyProjectId: number | null;
    readonly " $refType": "expenseRow_project";
};
export type expenseRow_project$data = expenseRow_project;
export type expenseRow_project$key = {
    readonly " $data"?: expenseRow_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"expenseRow_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "expenseRow_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = '2d4772e76bffab6372915dd4626e5a06';
export default node;
